import type { ObjectValues } from '~/@lib/utils/type.utils'

export const ProjectPaymentType = {
  QUARTERLY: 'wYtH2fcWv8fvnywF9',
  MONTHLY: 'NmMQDPs7fbinwaHJo',
  SEMI_ANNUALLY: 'GqBX9Z6cB9DKdrpY2',
  ANNUALLY: 'iKJoNu4imSMTZ596D',
  IN_THE_END: 'dW52PBdeLbgMmJXci',
  NONLINEARLY: 'g9GP3ZhJ9p6nRJkRh',

  // After migrating data in the DB:
  // QUARTERLY: "quarterly",
  // MONTHLY: "monthly",
  // ANNUALLY: "annually",
  // IN_THE_END: "in_the_end",
  // SEMI_ANNUALLY: "semi_annually",
  // NONLINEARLY: "nonlinearly",
} as const

// After migrating data in the DB:
export const ProjectPaymentType2 = {
  QUARTERLY: 'quarterly',
  MONTHLY: 'monthly',
  ANNUALLY: 'annually',
  IN_THE_END: 'in_the_end',
  SEMI_ANNUALLY: 'semi_annually',
  NONLINEARLY: 'nonlinearly',
} as const

export type ProjectPaymentType = ObjectValues<typeof ProjectPaymentType>
export type ProjectPaymentType2 = ObjectValues<typeof ProjectPaymentType2>

export type ProjectPaymentTypeLabels = ProjectPaymentType
